import { List } from '@iheartjane/reefer';

import type { CartLimitPolicyReport } from '@jane/shared/util';
import { formatWeight } from '@jane/shared/util';

import { Alert } from '../Alert';

export const CartLimitPolicyAlert = ({
  report,
}: {
  report?: CartLimitPolicyReport | null;
}) => {
  if (!report || !report.over) return null;

  const { overReports } = report;

  return (
    <List label="cart limit alerts list">
      {overReports.map((ruleReport) => {
        const {
          limit_unit_total,
          limit_value,
          limit_unit,
          product_group_name,
        } = ruleReport;

        const label = `To complete your order at this store, remove ${formatWeight(
          limit_unit_total - limit_value
        )} ${limit_unit} of ${product_group_name} products.`;

        return (
          <List.Item key={`${product_group_name}-${limit_unit}-${limit_value}`}>
            <Alert label={label} />
          </List.Item>
        );
      })}
    </List>
  );
};
